import { t9n } from '../lib/translate.js';
import { TS } from '../config/translation-keys.js';
import APIClient from '../state-charts/api-client';

export default class HistoryMachine {
  constructor(options) {
    this.make_context(options);
    this.add_computed_context();
  }

  make_context(options) {
    this.context = {
      // original context
      ...options.context,

      // static/parent data
      id: options.id,
      main: options.main,
      minimum_amount: options.main.context.pp_minimum,
      multiplier: options.main.context.pp_multiplier,
      currency_sign: options.main.context.currency_sign,
      amount: options.main.context.amount,
      role: options.main.context.user.last_role,

      // variables
      items: null,
      paging_data: null,
    };
  }

  add_computed_context() {
    // calculated variables
    this.context.cash_amount = this.context.amount / this.context.multiplier;

    this.context.amount_text = `${this.context.amount} (${this.context.cash_amount} ${this.context.currency_sign})`;

    // translations
    this.context.form_title = t9n(TS.PILOT_POINTS_HISTORY_FORM_TITLE);

    this.context.explanation = t9n(TS.PILOT_POINTS_HISTORY_EXPLANATION_LINE);

    this.context.total_label = t9n(TS.PILOT_POINTS_HISTORY_TOTAL_LABEL);

    this.context.date_label = t9n(TS.PILOT_POINTS_HISTORY_DATE_LABEL);

    this.context.type_label = t9n(TS.PILOT_POINTS_HISTORY_TYPE_LABEL);

    this.context.pp_label = t9n(TS.PILOT_POINTS_HISTORY_PP_LABEL);

    this.context.price_label = t9n(TS.PILOT_POINTS_HISTORY_PRICE_LABEL);

    this.context.transaction_label = t9n(
      TS.PILOT_POINTS_HISTORY_TRANSACTION_DATA_LABEL
    );

    this.context.comment_label = t9n(TS.PILOT_POINTS_HISTORY_COMMENT_LABEL);

    this.context.no_pp = t9n(TS.PILOT_POINTS_HISTORY_NO_HISTORY_LABEL);
  }

  update_context(context) {
    this.context = { ...this.context, ...context };
    this.add_computed_context();
  }

  async get_history(page, num) {
    let paging_info = {
      page: page ? page : 1,
      number_of_items_per_page: num ? num : 10,
    };

    let data = await APIClient.pilot_points_history(paging_info);

    if (!!data) {
      this.context.items = data.items;
      this.context.paging_data = data.results_info;

      // console.log('history', data.items);

      this.context.items.forEach(e => {
        if (e.type === 'history_type_billing_request') {
          if (e.billing_request?.amount) {
            e.pilot_points = e.billing_request.amount;
          }
        }

        if (e.billing_request?.id) {
          e.comment = t9n(
            TS.PILOT_POINTS_BY_BILLING_REQUEST,
            e.billing_request.id
          );
        }
      });
    }
  }

  get_item_data(item) {
    let email = '';
    let order = '';

    if (item.data.email) {
      email = item.data.email;
    }

    if (item.data.order_uuid) {
      if (this.context.role) {
        order = `<a href="/order-details?id=${item.data.order_uuid}">order: ${item.data.order_uuid}</a>`;
      } else {
        order = item.data.order_uuid;
      }
    }

    return [email, order].join('<br />').trim();
  }
}
